module.exports = __webpack_public_path__ + "img/second_sx.f21bc5d0.jpg";